export default {
  /*按钮*/
  bt:{
    search: "Search",
    query:"Query",
    operation:"operation",
    add:"Add",
    edit: "Modify",
    delete: "Delete",
    down: "Download",
    export:"Export",
    upload: "Upload",
    proposal:"审批",
    confirm:"确定",
    close:"关闭",
  },
  /*Public field or tool function field*/
  common:{
    startTime: "Start Time",
    endTime: "End Time",
    creator: "Creator",
    updater: "Updater",
    createTime: "Create Time",
    updateTime: "Update Time",
    phone:"Mobile Number",
    name:"Name",
    email:"Email",
    idNumber: "ID Number",
    status:"Status",
    remark: "Remarks",
  },
  active:{
    activeNo: "Activity Number",
    activeName: "Activity Name",
    activeTime: "active time",
    openTime: "Account Opening Time",
    status:"Activity Status",
    androidChannel: "android channel",
    iosChannel: "ios channel",
    review:"review",
    disable:"Disable",
    enable:"Enable",
    bonusDesc: "Bonus Description",
    url: "Link address",
    activeDescribe: "Activity Description",
    userList: "Blacklist",
    joinCustomerStatus: "Participating User Status",
    alwaysShow: "Whether tourists show red envelopes",
    limitType: "Limited time type",
    limitDays: "Limited time days",
    taskContent: "Tasks and Rewards",
    name:"Channel Name",
    pkg: "channel package name",
    os: "System Type",
    pleaseInput: "Please fill in",
    valid: "Data verification",
    enter: "OK",
    startTimeError: "Activity start time cannot be less than current time",
    taskContentComplete: "Activity start time cannot be less than current time",
    taskContentRepeat: "Do not set a repeat task",
    customerNo: "Account",
    task:"Task",
    startTime: "Activity start time",
    endTime: "Activity end time",
    customerCreateStartTime: "Account opening start time",
    customerCreateEndTime: "Account opening end time",
    customerActivatedStartTime: "Activated start time",
    customerActivatedEndTime: "Activated End Time",
    chineseName:"Customer Name",
    task1: "Open a real account",
    task3: "Complete information",
    task4: "First Deposit",
    task5: "Accumulated transaction of 1 hand of foreign exchange",
    task6: "Accumulated transaction of 1 lot of commodities",
    task7: "Accumulated trading 1 lot index",
    task8: "Accumulated transaction of 1 hand of digital currency",
    task9: "Trade Order",
    task10: "Accumulated trading 1 lot of stocks",
    customerCreateTime: "User Account Opening Time",
    customerActivatedTime: "User Activation Time",
    customerStatus: "User Status",
    amount:"Reward Amount",
    amountCny: "Reward amount (RMB)",
    selectTask: "Please select a task",
    taskTitle: "Task Title",
    taskDescribe: "Task Description",
    rewardValue: "Bonus amount ($)",
    orderNo: "Release Flow",
    taskName: "Task Name",
    platform:"platform",
  },

  pushMsg:{
    parent:"Subordinate to the business",
    appName:"The application name",
    status:"status",
    remark:"remark",
    appKey:"appKey",
    appSecret:"appSecret",
    createTime:"createTime",
    updateTime:"updateTime",
    updater:"updater",
    env:"Push the environment",
    prd:"The production environment",
    dev:"The development environment",
    check:"Switch the environment",
    isStop:"Determine the suspended?",
    isEnable:"Determine enabled?",
    fabu:"+Press release",
    releaseStatus:"Synchronized to the",
    msgTitle:"News headlines",
    business:"Subordinate to the business",
    platform:"Push platform",
    msgLanguage:"language",
    pushTime:"Push the time",
    pushConfig:"Push the configuration",
    type:"Message type",
    pushStatus:"Push state",
    msgPlatform:"Application platform",
    channel:"channel",
    targetUsers:"The target user",
    users:"The target user1",
    businessId:"Subordinate to the business",
    updateDate:"Modify the time",
    push:"synchronous",
    pushMode:"push",
    msgRemark:"Message description",
    msgContent:"The message content",
    fabudao:"Release to",
    fabuson:"Release people",
    yewu:"business",
    createDate:"Release time",
    createBy:"founder",
  },
  quantityTask:{
    ctime:"創建時間",
    customerNumber:"賬號",
    activeTime:"激活時間",
    userName:"用戶名",
    phone:"手機號",
    taskType:"任務類型",
    taskName:"任務名",
    quantity:"金幣值",
    businessType:"業務類型",
    companyId:"公司ID",
    detail:"詳情",
    status:"狀態",
    startTime:"開始時間",
    endTime:"結束時間",
    businessTypeAlias:"業務組別名",
    utime:"更新時間",
    uname:"操作人",
    taskStep:"活動階段",
    taskId:"活動ID",
    name:"名稱",
    rule:"活動規則",
    illustrate:"說明",
    title:"標題",
    category:"活動種類",
    addtionalConfig:"额外奖励设置",
    awardStatus:"領取狀態",
    finishedStatus:"完成狀態",
    typeName:"活動類型",
    type:"類型",
    proposalId:"提案號",
    taskStatus:"啟/禁",
    balance:"餘額",
    setting:"设置",
    exrate:"兌換比例",
    maxEx:"免審批額度（每天）",
    gmt:"GTM時區",
    examount:"兌換總額",
    proposalType:"提案類型",
    acceptTime:"領取時間",
    gtsManagerFac:"兌換通道",
    dicesDetailList:'明细记录详情',
  }
};
